import SoccerInformation from './Soccer';

export { SoccerInformation };
